<template>
    <div class="app-container mt-5 h-auto">
        <div class="d-flex justify-content-between">
            <div class="d-flex">
                <div class="page-title mb-3">
                    <span class="breadcrumb-link">
                        <v-icon class="breadcrumb-link-icon">search</v-icon> Veille
                    </span>
                </div>

                <div class="display-mode d-flex ml-5 pb-3" v-if="vtIsConfigured">
                    <div class="mt-auto mb-auto cliquable-state" :class="{ 'active': currentStep == 1 }"
                         @click="setCurrentStep(1)">
                        <div class="d-flex">
                        <span class="mt-1">
                            Mises à jour
                        </span>
                            <span class="ml-2 bg-primary vtc-count mt-1"
                                  v-if="vtc.waiting_diffs_count > 0">
                            {{ vtc.waiting_diffs_count }}
                        </span>
                        </div>
                    </div>

                    <div class="mt-auto mb-auto cliquable-state" :class="{ 'active': currentStep == 2 }"
                         @click="loadVtcHistory">
                        <div class="d-flex">
                        <span class="mt-1">
                            <v-icon left color="primary">history</v-icon>
                            Historique
                        </span>
                        </div>
                    </div>

                    <div class="mt-auto mb-auto cliquable-state" :class="{ 'active': currentStep == 3 }"
                         @click="setCurrentStep(3)">
                        <div class="d-flex">
                        <span class="mt-1">
                        Prestataires
                        </span>
                            <span class="ml-2 bg-warning vtc-count mt-1"
                                  v-if="vtc.providers_with_no_google_source > 0">
                            {{ vtc.providers_with_no_google_source }}
                        </span>
                        </div>
                    </div>
                </div>

                <span v-if="!vtc.active"
                      class="ml-3 mb-3 text-warning"
                      style="align-items: center; display: flex">
                    <v-icon color="warning" left>pause</v-icon>
                    Veille suspendue
                </span>
            </div>

            <div v-if="vtIsConfigured && currentStep == 3" class="d-flex">
                <div class="mr-3">
                    <v-menu bottom transition="slide-y-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="default-button" v-on="on" :disabled="!selectedProvidersFromVtcList.length">
                                Sur la sélection
                                <v-icon>arrow_drop_down</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item @click="removeProviders">
                                <v-list-item-title>
                                    Retirer de la veille les prestataires sélectionnés
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>

                <div>
                    <v-btn outlined class="custom-button-error"
                           v-if="vtc.last_import_failed">
                        <v-icon left>warning</v-icon>
                        Import échoué
                    </v-btn>
                    <v-btn outlined class="custom-button-primary" disabled style="background-color: #0000001f"
                           v-else-if="vtc.import_in_progress">
                        <v-icon left>pending_actions</v-icon>
                        Import en cours
                    </v-btn>
                    <v-btn outlined class="custom-button-primary" @click="redirectToAddProviders" v-else>
                        <v-icon left>add</v-icon>
                        Ajouter des prestataires
                    </v-btn>
                </div>
            </div>
        </div>

        <div class="form-container mr-auto ml-auto mt-3" v-if="vtc.last_import_failed">
            <v-alert type="error" class="mt-5 mb-5 mr-auto ml-auto text-danger" border="right" colored-border>
                Votre dernier import de prestataire a échoué, merci de contacter le support.
            </v-alert>
        </div>

        <div v-if="!vtIsConfigured" class="text-center d-flex flex-column pt-12">
            <div>
                <button class="text-center cadh-add-button" @click="redirectToVtcConfig">
                    <span class="font-weight-bold h4">
                        <v-icon left color="white">settings</v-icon>
                        Configurer ma veille
                    </span>
                </button>
            </div>
        </div>

        <v-stepper @change="setCurrentStep" non-linear :value="currentStep" v-else
                   class="w-100 h-auto config-stepper">
            <v-stepper-items class="w-100 mx-0 px-0">
                <v-stepper-content class="py-2 pr-0 mr-0" step="1">
                    <vtc-waiting-diffs :languages="languages"></vtc-waiting-diffs>
                </v-stepper-content>

                <v-stepper-content class="py-2 pr-0 mr-0" step="2">
                    <vtc-history :languages="languages"></vtc-history>
                </v-stepper-content>

                <v-stepper-content class="py-0" step="3">
                    <vtc-providers></vtc-providers>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import VtcProviders from "./VtcProviders.vue"
import VtcWaitingDiffs from "./VtcWaitingDiffs.vue"
import VtcHistory from "./VtcHistory.vue"
import _ from "lodash"
import Confirm from "../tools/Confirm.vue"

export default {
    name: "VtCampaign",
    components: { VtcProviders, VtcWaitingDiffs, Confirm, VtcHistory },
    data() {
        return {
            updateStateModal: false,
            vtIsConfigured: false,
            languages: [],
        }
    },
    methods: {
        ...mapMutations("vtc", [
            "setCurrentStep",
            "setVtc",
            "setProviders",
            "setTreatedVtcDiffs",
            "setSelectedProvidersFromVtcList",
        ]),
        getLanguages() {
            this.$http.get("resource/languages").then(res => {
                this.languages = res.body.data.languages
            })
        },
        hasActiveProviderFilters() {
            return Boolean(
                this.search ||
                (this.selectedCategories && this.selectedCategories.length > 0) ||
                (this.selectedCommunes && this.selectedCommunes.length > 0) ||
                (this.selectedProviderStates && this.selectedProviderStates.length > 0) ||
                (this.selectedBusinessStatus && this.selectedBusinessStatus.length > 0)
            )
        },
        getVtc(reloadProviders = true) {
            this.$global.loading = true

            let payload = {
                accountId: this.account.id,
                searchName: this.waitingDiffSearchName,
                sortOrder: this.waitingVtcDiffSortOrder,
            }

            this.$http.post("/veille-tourisme/vtc", payload).then((res) => {
                if (res.body.success && res.body.data.vtc !== null) {
                    this.vtIsConfigured = true
                    this.setVtc(res.body.data.vtc)
                    if (reloadProviders) {
                        if (this.hasActiveProviderFilters()) {
                            this.getVtcProviders()
                        } else {
                            this.setProviders(Object.values(res.body.data.vtc.providers))
                            this.$global.loading = false
                        }
                    } else {
                        this.$global.loading = false
                    }
                } else if (res.body.data.vtc === null) {
                    this.vtIsConfigured = res.body.data.vtcConfigId !== null
                    this.$global.loading = false
                }

                if (this.$route.path.includes("import-in-progress") && this.vtc.import_in_progress) {
                    this.$global.$emit("success-request", {
                        body: {
                            message:
                              "Nous ajoutons vos prestataires à la veille, ceci peut prendre quelques minutes.",
                        },
                    })
                }
            })
        },
        redirectToAddProviders() {
            this.$router.push("/veille/vtc/add-providers")
        },
        getVtcProviders: _.debounce(function() {
            let payload = {
                search: this.search,
                categories: this.selectedCategories,
                communes: this.selectedCommunes,
                vtcProviderStates: this.selectedProviderStates,
                businessStatus: this.selectedBusinessStatus,
                vtcId: this.vtc.id,
            }

            this.$global.loading = true

            this.$http.post("veille-tourisme/vtc/providers", payload).then(res => {
                this.setProviders(Object.values(res.body.data.providers))

                this.$global.loading = false
            })
        }, 300),
        redirectToVtcConfig() {
            this.$router.push("/configuration/veille")
        },
        removeProviders() {
            let payload = {
                vtcId: this.vtc.id,
                providerIds: this.selectedProvidersFromVtcList.map((provider) => provider.id),
            }

            this.$refs.confirm.open("Attention",
              "Etes-vous sûr de vouloir retirer ces prestataires de la veille ?", { color: "red" }).then(
              (confirm) => {
                  if (confirm) {
                      this.$global.loading = true
                      this.$http.put("veille-tourisme/vtc/providers/remove-multiple", payload).then(res => {
                          this.$global.$emit("reload-providers")
                          this.setVtc(res.body.data.vtc)
                          this.setSelectedProvidersFromVtcList([])
                          this.$global.loading = false
                      })
                  }
              },
            )
        },
        loadVtcHistory() {
            if (this.vtc.id) {
                this.$global.loading = true

                let payload = {
                    vtcId: this.vtc.id,
                    searchName: this.treatedVtcDiffsSearchName,
                    sortOrder: this.treatedVtcDiffSortOrder,
                }

                this.$http.post("veille-tourisme/vtc/treated-vtc-diffs", payload).then(res => {
                    this.setTreatedVtcDiffs(res.body.data.treatedVtcDiffs)
                    this.$global.loading = false
                })
            }

            this.setCurrentStep(2)
        },
    },
    computed: {
        ...mapState("account", [
            "account",
        ]),
        ...mapState("vtc", [
            "vtc",
            "currentStep",
            "selectedProvidersFromVtcList",
            "treatedVtcDiffsSearchName",
            "waitingDiffSearchName",
            "waitingVtcDiffSortOrder",
            "treatedVtcDiffSortOrder",
        ]),
        ...mapState("vtcFilter", [
              "search",
              "selectedCategories",
              "selectedProviderStates",
              "selectedTags",
              "selectedCommunes",
              "selectedTourismSectors",
              "emailSearch",
              "selectedBusinessStatus",
          ],
        ),
    },
    watch: {
        treatedVtcDiffsSearchName() {
            this.loadVtcHistory()
        },
        waitingDiffSearchName() {
            this.getVtc(false)
        },
        waitingVtcDiffSortOrder() {
            this.getVtc(false)
        },
        treatedVtcDiffSortOrder() {
            this.loadVtcHistory()
        },
    },
    created() {
        this.getVtc()
        this.getLanguages()

        this.$global.$on("reload-vtc", (step) => {
            this.getVtc(step == 3)
            if (step == 2) {
                this.loadVtcHistory()
            } else {
                this.setCurrentStep(step)
            }
        })

        this.$global.$on("reload-providers", () => {
            this.getVtcProviders()
            this.setCurrentStep("3")
        })
    },
    beforeDestroy() {
        this.$global.$off("reload-vtc")
        this.$global.$off("reload-providers")
    },
}
</script>